import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthLayout } from '@/components/layout/AuthLayout';
import { ResetPasswordForm } from '../components/ResetPasswordForm';
import { supabase } from '@/lib/supabase';
import { useAuth } from '../hooks/useAuth';  // ADD THIS IMPORT

export function ResetPasswordPage() {
  const navigate = useNavigate();
  const { isAuthenticated, isPasswordRecoveryMode } = useAuth();  // ADD THIS LINE
  const [isValidSession, setIsValidSession] = useState<boolean | null>(null);

  useEffect(() => {
    // If user is fully authenticated (not in recovery mode), redirect to dashboard
    if (isAuthenticated && !isPasswordRecoveryMode) {
      navigate('/dashboard', { replace: true });
      return;
    }

    // Check if user has a valid recovery session
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      
      // User should have a session from the password recovery link
      if (!session) {
        // No session - redirect to forgot password
        navigate('/forgot-password');
        return;
      }
      
      setIsValidSession(true);
    };

    checkSession();
  }, [navigate, isAuthenticated, isPasswordRecoveryMode]); 

  if (isValidSession === null) {
    return (
      <AuthLayout title="Loading..." subtitle="">
        <div className="flex justify-center py-8">
          <svg
            className="animate-spin h-8 w-8 text-primary-600"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Reset password" subtitle="Enter your new password below">
      <ResetPasswordForm />
    </AuthLayout>
  );
}